import { Directive } from '@angular/core';
@Directive({
  selector: '[fUserMenuContainer]',
  standalone: false
})
export class UserMenuContainerDirective {}
